import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useLocation } from "react-router-dom";

import {
  Stepper,
  Step,
  StepLabel,
  Typography,
  Button,
  Box,
} from "@mui/material";
import NavbarSidebarLayout from "../../../components/Dashboard/Layouts/NavbarSidebar";
import ServerStatus from "../../../components/ServerStatus";

import { api } from "../../../config/config";

import { EmailRegex } from "../../../components/Validation/EmailRegex";
import { PhoneRegex } from "../../../components/Validation/PhoneRegex";
import { PieceValidation } from "../../../components/Validation/PieceValidation";

// import InfoService from "../../../components/InfoService/InfoService";
import CnibValid from "../../../components/Functions/CnibValid";
import StepActionComponent from "../components/StepActionComponent";
import ClientTypeSelection from "../../../components/demande/ClientTypeSelection";
import { handleFileUpload } from "../../../services/uploadService";

import ConditionsDemande from "../../../components/demande/ConditionsDemande";
import DemandeurInfoForm from "../../../components/demande/DemandeurInfoForm";
import IdentityForm from "../../../components/demande/IdentityForm";
import LocationForm from "../../../components/demande/LocationForm";
import ParcelOwnerForm from "../../../components/demande/ParcelOwnerForm";
import Branchementform from "../../../components/demande/BranchementForm";
import ConfirmationSection from "../../../components/demande/ConfirmationSection";
import BreadcrumbsComponent from "../../../components/demande/BreadcrumbsComponent";
import { TitleComponent } from "../../../components/demande/TitleComponent";

import { ConditionsMessagesBranchement } from "../../../components/demande/ConditionMessages";
import { SEXE_OPTIONS } from "../../../shared/constants";
import ActivitePdecForm from "../../../components/demande/ActivitePdecForm";

const typeBranchement = "sansAbon";

const BrancheSanAbon = ({ serverOffline }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);

  const [formData, setFormData] = useState({
    typeClient: "particulier",
    service: "",
    exploitation: "",
    section: "",
    lot: "",
    parcelle: "",
    rang: "",
    nom: "",
    prenom: "",
    email: "",
    tel2: "+226",
    tel1_whatsapp: "+226",
    numero_rccm: "",
    numero_ifu: "",
    pb: "",
    profession_id: "",
    piece: "",
    lieu_etablissement: "",
    date_etablissement: "",
    numero_piece: "",
    latitude: "",
    longitude: "",
    puissance: "",
    compteur: "",
    type_amperage: "monophasé", // triphasé
    police: "",
    region: "",
    province: "",
    ville_id: "",
    village_id: "",
    nom_entreprise: "",
    prop_nom: "",
    prop_prenom: "",
    file: null,
    tableaux: [],
    sexe: SEXE_OPTIONS[0].value,
    activite_pdec_id: "",
  });
  const [errors, setErrors] = useState({});

  // La liste de professions
  const [professions, setProfessions] = useState([]);
  const [activitesPdec, setActivitesPdec] = useState([]);
  // liste de villes
  const [villes, setVilles] = useState([]);
  // liste des villages
  const [villages, setVillages] = useState([]);

  // deactiver le bouton submit lorsqu'on actionne le bouton soumettre
  const [stateSend, setStateSend] = useState(true);

  const [isLoading, setIsLoading] = useState(false);
  const [errorDate, setErrorDate] = useState(false);

  const avertissement = <p className="text-red-600">Avertissement</p>;

  const [showDialog, setShowDialog] = useState(false);
  const [selectedBranchement, setSelectedBranchement] = useState(null);

  // cela permet de savoir si l'on modifie une valeur existante ou si on
  // si on veut veux faire une incrementation
  // edit => on garde la valeur fourni
  // add => on ajout la valeur fournie à la valeur existante
  const [status, setStatus] = useState("edit"); // add

  // Chargement des villes, professions et activites PDEC
  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        // Exécution parallèle des deux appels
        const [villesResponse, activitesResponse, professionsResponse] =
          await Promise.all([
            api.get("/ville/cd"),
            api.get("/activitepdec/all"),
            api.get("/profession/all"),
          ]);

        if (!isMounted) return;

        // Traitement des villes
        if (villesResponse.status === 200) {
          const trimmedVilles = villesResponse.data.content.map((ville) => ({
            id: ville.id,
            name: ville.agence.trim(),
          }));
          setVilles(trimmedVilles);
        }

        // Traitement des activités
        if (activitesResponse.status === 200) {
          const secteurActivite = activitesResponse.data.content.map(
            (activite) => ({
              id: activite.ID,
              name: activite.LIBELLE_ACTIVITE.trim(),
              code_activite: activite.CODE_ACTIVITE.trim(),
              key_words: activite.KEYWORDS.trim(),
            }),
          );
          setActivitesPdec(secteurActivite);
        }

        // Traitement des professions
        if (professionsResponse.status === 200) {
          setProfessions(professionsResponse.data.content);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des données:", error);
        // Gérer l'erreur (toast, message, etc.)
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  const steps = [
    avertissement,
    "Type de client",
    "Informations du client",
    "Informations d'identité",
    "Localisation géographique",
    "Information cadastrale de la parcelle",
    "Information sur le branchement",
    "Secteur d'activité",
    "Validation",
  ];

  const handleNext = () => {
    const validationErrors = validateForm(formData);
    if (Object.keys(validationErrors).length === 0) {
      setErrors({});
      //setStateSend(true);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      setErrors(validationErrors);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setStateSend(false);
  };

  /**
   * Recuperer les donnees des
   * champs du formulaire
   *
   */
  const handleChange = (field, value) => {
    setFormData((prevData) => ({ ...prevData, [field]: value }));
  };

  const handleChangeVille = (_, value) => {
    setVillages([]); // met la liste des village a zero
    let valeur = value === undefined || value === null ? "" : value?.id;
    //setFormData((prevData) => ({ ...prevData, ville: value?.id }));
    setFormData((prevData) => ({ ...prevData, ville_id: valeur }));
    setIsLoading(true);
    api
      .get(`/village/ville/${value?.id}`)
      .then((response) => {
        if (response.status === 200) {
          const trimmedVillages = response.data.content.map((village) => ({
            id: village?.id,
            name: village?.localite.trim(),
          }));
          setVillages(trimmedVillages);
          setIsLoading(false);
        }
      })
      .catch(() => {});
  };

  const handleFieldFocus = (field) => {
    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
  };

  // Validation des champs du formulaire
  const validateForm = (formData) => {
    //if (!str.trim()) → Vérifie si str est vide ou ne contient que des espaces.
    const errors = {};
    // Validation en fonction de l'étape active
    if (activeStep === 2) {
      if (!formData.nom.trim()) {
        errors.nom = "Nom obligatoire";
      } else if (formData.nom.trim().length > 25) {
        errors.nom = "Le nom ne doit pas dépasser 25 caractères";
      }
      if (!formData.prenom.trim()) {
        errors.prenom = "Prenom obligatoire";
      } else if (formData.prenom.trim().length > 25) {
        errors.prenom = "Le prénom ne doit pas dépasser 25 caractères";
      }

      // Validation de l'email
      // valider uniquement si le champ email est renseigné
      // car ce n'est plus un champ obligatoire
      if (formData.email.trim()) {
        if (!EmailRegex(formData.email.trim())) {
          errors.email = "Format d'email invalide";
        }
      }
      // Validation de l'email
      /*   if (!formData.email.trim()) {
        errors.email = "Email obligatoire";
      } else if (!EmailRegex(formData.email.trim())) {
        errors.email = "Format d'email invalide";
      } */

      // Validation du numéro de téléphone
      if (!formData.tel2.trim() || formData.tel2.length < 8) {
        errors.telephone = "Téléphone obligatoire";
      } else if (!PhoneRegex(formData.tel2)) {
        errors.telephone =
          "Le numéro de téléphone doit être au format correct.";
      }

      // Validation du numéro WhatsApp
      /*   if (!formData.tel1_whatsapp.trim() || formData.tel1_whatsapp.length < 8) {
        errors.whatsApp = "Téléphone obligatoire";
      } else if (!PhoneRegex(formData.tel1_whatsapp)) {
        errors.whatsApp = "Le numéro de téléphone doit être au format correct.";
      }
 */
      const normalizedWhatsapp = formData.tel1_whatsapp.trim();
      const hasWhatsappNumber =
        normalizedWhatsapp && normalizedWhatsapp !== "+226";

      if (hasWhatsappNumber) {
        if (!PhoneRegex(normalizedWhatsapp)) {
          errors.whatsApp =
            "Le numéro de téléphone doit être au format correct.";
        }
      }

      // Validation de la profession
      if (!formData.profession_id) {
        errors.profession =
          "Veuillez choisir une profession ou secteur d'activité";
      }
      // Validation des informations de l'entreprise
      if (formData.typeClient === "entreprise") {
        if (!formData.numero_rccm.trim()) {
          errors.rccm = "RCCM obligatoire";
        } else if (formData.numero_rccm.trim().length > 30) {
          errors.rccm = "Le RCCM ne doit pas dépasser 30 caractères";
        }
        if (!formData.nom_entreprise.trim()) {
          errors.nom_entreprise = "Nom Entreprise obligatoire";
        } else if (formData.nom_entreprise.trim().length > 30) {
          errors.nom_entreprise =
            "Le nom de l'entreprise ne doit pas dépasser 30 caractères";
        }
        if (!formData.numero_ifu.trim()) {
          errors.ifu = "Numéro IFU obligatoire";
        } else if (formData.numero_ifu.trim().length > 30) {
          errors.ifu = "Le numéro IFU ne doit pas dépasser 30 caractères";
        }
      }
    } else if (activeStep === 3) {
      // Validation des pièces d'identité
      if (!formData.numero_piece.trim() || formData.numero_piece.length < 8) {
        errors.numero_piece = "Numéro pièce obligatoire";
      }
      if (!formData.piece) {
        errors.piece = "Type pièce obligatoire";
      }

      // Validation du fichier
      if (!formData.file) {
        errors.file = "Ce champ est obligatoire";
      } else if (formData.file.size > 2 * 1024 * 1024) {
        errors.file = "Le fichier sélectionné est trop volumineux.";
      } else if (!formData.file.name.toLowerCase().endsWith(".pdf")) {
        errors.file = "Le fichier doit être un PDF";
      }

      // Validation de la date d'établissement
      if (!formData.date_etablissement.trim()) {
        errors.date_piece = "La date d'établissement est obligatoire";
        setErrorDate(true);
      } else if (PieceValidation(formData.date_etablissement) === false) {
        errors.date_piece = "Cette date ne peut pas être acceptée.";
        setErrorDate(true);
      }

      // Vérification de l'expiration de la carte d'identité
      if (CnibValid(formData.date_etablissement) >= 10) {
        errors.date_piece = "Votre carte d'identité a expiré.";
        setErrorDate(true);
      }

      // Validation du lieu d'établissement de la pièce
      if (!formData.lieu_etablissement.trim()) {
        errors.lieu_piece = "Lieu d'établissement de la pièce obligatoire";
      }
    } else if (activeStep === 4) {
      // Validation de la zone administrative
      if (!formData.ville_id) {
        errors.ville = "La zone administrative est obligatoire";
      }
      // Validation de la localité
      if (!formData.village_id) {
        errors.village = "La localité est obligatoire";
      }
    } else if (activeStep === 5) {
      // Validation des informations du propriétaire
      if (!formData.prop_nom.trim()) {
        errors.prop_nom = "Ce champ est obligatoire";
      } else if (formData.prop_nom.trim().length > 15) {
        errors.prop_nom = "Le nom ne doit pas dépasser 15 caractères";
      }
      if (!formData.prop_prenom.trim()) {
        errors.prop_prenom = "Ce champ est obligatoire";
      } else if (formData.prop_prenom.trim().length > 20) {
        errors.prop_prenom = "Le prénom ne doit pas dépasser 20 caractères";
      }
      if (!formData.lot.trim()) {
        errors.lot = "Numéro lot obligatoire";
      }
      if (!formData.parcelle.trim()) {
        errors.parcelle = "Numéro parcelle obligatoire";
      }
      if (!formData.section.trim()) {
        errors.section = "Numéro section obligatoire";
      }

      // Validation du fichier document_parcelle
      if (!formData.document_parcelle) {
        errors.document_parcelle =
          "Le document de la parcelle est obligatoire.";
      } else if (formData.document_parcelle.size > 2 * 1024 * 1024) {
        errors.document_parcelle =
          "Le fichier sélectionné est trop volumineux.";
      } else if (
        !formData.document_parcelle.name.toLowerCase().endsWith(".pdf")
      ) {
        errors.document_parcelle = "Le fichier doit être un PDF.";
      }
    } else if (activeStep === 6) {
      if (formData.tableaux.length <= 0) {
        errors.branchement = "Veuillez ajouter un branchement";
      }
    } else if (activeStep === 7) {
      // validation de l'activite activite_pdec
      if (!formData.activite_pdec_id) {
        errors.activite_pdec = "Veuillez choisir un segement d'activité";
      }
    }
    return errors;
  };

  /**
   * Envoi de la demande
   * @param {String} cnib - le nom de la CNIB deja uploadé
   * @param {String} parcelle  - Le nom du fichier de La parcelle deja unpload
   */
  const handleDemande = async (cnib, parcelle) => {
    if (cnib && parcelle) {
      const validationErrors = validateForm(formData);
      if (Object.keys(validationErrors).length === 0) {
        setErrors({});
        const normalizedWhatsapp = formData.tel1_whatsapp.trim();
        const tel1_whatsapp =
          normalizedWhatsapp && normalizedWhatsapp !== "+226"
            ? normalizedWhatsapp
            : "";

        const demandeService = {
          lot: formData.lot,
          parcelle: formData.parcelle,
          type_sce: location.state.idBranchementAbon,
          nom: formData.nom,
          prenom: formData.prenom,
          /*   tel1_whatsapp: formData.telephone.replace(/\s+/g, ""),
          tel2: formData.whatsApp.replace(/\s+/g, ""), */
          tel1_whatsapp: tel1_whatsapp.replace(/\s+/g, ""),
          tel2: formData.tel2.replace(/\s+/g, ""),
          email: formData.email,
          numero_ifu: formData.numero_ifu,
          numero_rccm: formData.numero_rccm,
          ville_id: formData.ville_id,
          village_id: formData.village_id,
          profession_id: formData.profession_id,
          type_amperage: formData.type_amperage,
          puissance: formData.puissance,
          numero_piece: formData.numero_piece,
          piece: formData.piece,
          date_etablissement: formData.date_etablissement,
          lieu_etablissement: formData.lieu_etablissement,
          section: formData.section,
          user_id: localStorage.getItem("userId"),
          nom_entreprise: formData.nom_entreprise,
          prop_nom: formData.prop_nom,
          prop_prenom: formData.prop_prenom,
          cat_cli_code: "",
          photo_piece: cnib,
          document_parcelle: parcelle,
          tableaux: formData.tableaux,
          // PDEC
          activite_pdec_id: formData.activite_pdec_id,
          sexe: formData.sexe,
        };
        if (formData.typeClient === "particulier") {
          demandeService.cat_cli_code = "00";
        } else {
          demandeService.cat_cli_code = "02";
        }
        // Supprimer les valeurs `null`
        const filteredDataBranchSansAbon = Object.fromEntries(
          Object.entries(demandeService).filter(
            ([key, value]) => value !== null,
          ),
        );
        // Soumettre la demande du client
        try {
          setIsLoading(true);
          await api
            .post("/demande", filteredDataBranchSansAbon)
            .then((response) => {
              if (response.status === 201) {
                setFormData({
                  typeClient: "particulier",
                  //Initialiser avec les valeurs par défaut du formulaire
                  service: "",
                  exploitation: "",
                  section: "",
                  lot: "",
                  parcelle: "",
                  rang: "",
                  nom: "",
                  prenom: "",
                  email: "",
                  tel2: "+226",
                  tel1_whatsapp: "+226",
                  numero_rccm: "",
                  numero_ifu: "",
                  pb: "",
                  profession: "",
                  piece: "CNI",
                  lieu_etablissement: "",
                  date_etablissement: "",
                  numero_piece: "",
                  latitude: "",
                  longitude: "",
                  puissance: "3A",
                  compteur: "",
                  type_amperage: "monophasé", // triphasé
                  police: "",
                  region: "",
                  province: "",
                  ville_id: "",
                  village_id: "",
                  nom_entreprise: "",
                  prop_nom: "",
                  prop_prenom: "",
                  document_parcelle: "",
                  file: null,
                  tableaux: [],
                  sexe: SEXE_OPTIONS[0].value,
                  activite_pdec_id: "",
                });
                toast.success(
                  "Demande enregistrée ! Nous vous enverrons des notifications pour le suivi de la demande par mail ou SMS.",
                );
                setIsLoading(false);
                setStateSend(true); // désactiver le bouton
                setTimeout(() => {
                  navigate("/dashboard");
                }, 2000);
              }
            })
            .catch((err) => {
              if (err.response?.status === 404) {
                setIsLoading(false);
                setStateSend(false);
                toast.error("La section saisie n'est pas valide.");
              } else {
                setIsLoading(false);
                setStateSend(false);
                toast.error("Demande non enregistré");
              }
            });
          // setErrorMessage("");
        } catch (erreur) {}
      } else {
        setErrors(validationErrors);
      }
    } else {
      toast.error("Demande non enregistré");
    }
  };

  // Controller les numero de téléphone
  const handleChangePhone = (value) => {
    setFormData((prevData) => ({ ...prevData, tel2: value }));
  };

  //Whatsapp
  const handleChangePhoneWhatsapp = (valueWhatsapp) => {
    setFormData((prevData) => ({ ...prevData, tel1_whatsapp: valueWhatsapp }));
  };

  const handleFileChange = (event) => {
    setFormData((prevData) => ({ ...prevData, file: event.target.files[0] }));
  };

  const handleFileDocumentChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      document_parcelle: event.target.files[0],
    }));
  };

  const handleManageDataSend = async () => {
    setStateSend(true);
    try {
      // On upload le fichier de la cnib et document de la parcelle
      const cnibFile = await handleFileUpload(formData.file, setIsLoading);
      const parcelleFile = await handleFileUpload(
        formData.document_parcelle,
        setIsLoading,
      );
      if (cnibFile && parcelleFile) {
        // upload de la demande
        await handleDemande(cnibFile, parcelleFile);
      }
    } catch (e) {
      /* console.error("Erreur lors de la gestion des fichiers :", e); */
    } finally {
      setStateSend(false);
    }
  };

  const handleAcceptTermsAndCondition = async (event) => {
    setStateSend(!event.target.checked);
  };

  // Ajout des branchements
  const addBranchement = (nouveauBranchement) => {
    const { amperage, branchement, tableau } = nouveauBranchement;

    const branchementIndex = formData.tableaux.findIndex(
      (b) =>
        b.amperage === amperage &&
        b.branchement === branchement &&
        b.tableau === tableau,
    );

    setFormData((prev) => {
      const tableaux = [...prev.tableaux];

      if (branchementIndex !== -1) {
        // Si branchement existe
        const updatedBranchement = { ...tableaux[branchementIndex] };

        if (status === "add") {
          updatedBranchement.nombre =
            parseInt(updatedBranchement.nombre) +
            parseInt(nouveauBranchement.nombre);
        } else if (status === "edit") {
          updatedBranchement.nombre = parseInt(nouveauBranchement.nombre);
        }

        tableaux[branchementIndex] = updatedBranchement;
      } else {
        // Nouveau branchement à ajouter
        tableaux.push(nouveauBranchement);
      }

      return {
        ...prev,
        tableaux,
      };
    });
  };

  /*   // Ajout des branchements
  const addBranchement = (nouveauBranchement) => {
    // Recherche d'une occurence de branchement avec la meme puissance
    const branchementIndex = formData.tableaux.findIndex(
      (branchement) =>
        branchement.amperage === nouveauBranchement.amperage &&
        branchement.branchement === nouveauBranchement.branchement
    );

    if (branchementIndex !== -1) {
      // Si branchement existe, on met à jour le nombre de tableau
      // En ajoutant si nous sommes en ajout
      if (status === "add") {
        setFormData((prev) => ({
          ...prev,
          tableaux: prev.tableaux.map((branchement, index) =>
            index === branchementIndex
              ? {
                  ...branchement,
                  nombre:
                    parseInt(branchement.nombre) +
                    parseInt(nouveauBranchement.nombre),
                }
              : branchement
          ),
        }));
      } else if (status === "edit") {
        // En grand la valeur modifier si nous sommes en modification
        setFormData((prev) => ({
          ...prev,
          tableaux: prev.tableaux.map((branchement, index) =>
            index === branchementIndex
              ? {
                  ...branchement,
                  nombre: parseInt(nouveauBranchement.nombre),
                }
              : branchement
          ),
        }));
      }
    } else {
      // Si branchement n'existe pas, on ajoute un nouveau branchement
      setFormData((prev) => ({
        ...prev,
        tableaux: [...prev.tableaux, nouveauBranchement],
      }));
    }
  }; */

  // Supprimer un branchement par index
  const removeBranchement = (id) => {
    setFormData((prev) => ({
      ...prev,
      tableaux: prev.tableaux.filter((_, index) => index !== id),
    }));
  };

  // Modifier un branchement
  const editBranchement = (indexBranchement) => {
    // On recupere le branchement à partir de son index

    const branchement = formData.tableaux[indexBranchement];

    // Puis le passe au state branchement
    setSelectedBranchement(branchement);
    setStatus("edit");
    setShowDialog(true);
  };

  // Fermer le diaglog
  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  // Ouvrir le modal pour l'ajout
  const handleAdd = () => {
    setStatus("add");
    setShowDialog(true);
    // initialiser le branchement avec des valeurs par defaut selon le type de branchement
    setSelectedBranchement({
      branchement: "monophasé", // triphasé
      amperage: "3A",
      nombre: "1",
      tableau: "",
    });
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return <ConditionsDemande message={ConditionsMessagesBranchement} />;
      case 1:
        return (
          <ClientTypeSelection
            formData={formData}
            handleChange={handleChange}
            action="ajout"
          />
        );
      case 2:
        return (
          <DemandeurInfoForm
            formData={formData}
            errors={errors}
            professions={professions}
            handleChange={handleChange}
            handleFieldFocus={handleFieldFocus}
            handleChangePhone={handleChangePhone}
            handleChangePhoneWhatsapp={handleChangePhoneWhatsapp}
          />
        );
      case 3:
        return (
          <IdentityForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
            handleFieldFocus={handleFieldFocus}
            handleFileChange={handleFileChange}
            setErrorDate={setErrorDate}
            errorDate={errorDate}
          />
        );
      case 4:
        return (
          <LocationForm
            formData={formData}
            errors={errors}
            villes={villes}
            villages={villages}
            handleChangeVille={handleChangeVille}
            handleChange={handleChange}
            isLoading={isLoading}
          />
        );
      case 5: //  Inos sur la parcelle
        return (
          <ParcelOwnerForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
            handleFieldFocus={handleFieldFocus}
            handleFileDocumentChange={handleFileDocumentChange}
          />
        );
      case 6:
        return (
          <Box component="div">
            <Button variant="outlined" onClick={handleAdd}>
              Ajouter un branchement
            </Button>
            <Branchementform
              formData={formData}
              errors={errors}
              addBranchement={addBranchement}
              removeBranchement={removeBranchement}
              editBranchement={editBranchement}
              branchement={selectedBranchement}
              openDialog={showDialog}
              onCloseDialog={handleCloseDialog}
              typeBranchement={typeBranchement}
            />
          </Box>
        );
      case 7:
        return (
          <ActivitePdecForm
            formData={formData}
            activitesPdec={activitesPdec}
            errors={errors}
            handleChange={handleChange}
            handleFieldFocus={handleFieldFocus}
          />
        );
      case 8:
        return (
          <ConfirmationSection
            handleAcceptTermsAndCondition={handleAcceptTermsAndCondition}
            typeDemande="sanAbon"
          />
        );
      default:
        return "Unknown step";
    }
  };

  return (
    <>
      <ToastContainer />
      <NavbarSidebarLayout>
        {serverOffline && <ServerStatus />}
        <div className="block items-center justify-center border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
          <div className="mb-1 w-full">
            <BreadcrumbsComponent service="Branchement sans abonnement" />
            <div>
              <div className="my-8">
                <TitleComponent title="Branchement sans Abonnement" />

                <div className="flex w-full flex-col gap-y-6 lg:flex-row lg:justify-center lg:gap-y-0 md:flex-row md:justify-center md:gap-y-0">
                  <div className=" rounded-lg bg-white p-2 shadow-2xl dark:bg-gray-800  xl:p-8 lg:w-1/2 border-2 lg:p-5">
                    <div className="invisible md:visible">
                      <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{/*label*/}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </div>
                    <div>
                      <Typography className="text-center mb-8" variant="h5">
                        {steps[activeStep]}
                      </Typography>
                      {getStepContent(activeStep)}

                      <StepActionComponent
                        activeStep={activeStep}
                        steps={steps}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        handleManageDataSend={handleManageDataSend}
                        stateSend={stateSend}
                        isLoading={isLoading}
                        serverOffline={serverOffline}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </NavbarSidebarLayout>
    </>
  );
};

export default BrancheSanAbon;
